/**
 * Address Module Hooks
 * @see mobile: module-customer/src/modules/addresses/hooks/index.ts
 */

// Core hooks (exported in mobile)
export * from './use-get-region-list-address.hooks';
export * from './use-handle-address-form.hooks';
export * from './use-handle-address-form-mutation.hooks';

// Additional hooks (available in mobile but not exported from index)
export { useAddressBook } from './use-address-book';
export { useExtractCustomerAddressInformation } from './use-extract-customer-address-information';
export type { CustomerAddressInformation } from './use-extract-customer-address-information';
export { useGetAddressInfo, addressTypeVal } from './use-get-address-type-info';
export type { UseGetAddressInfoReturn } from './use-get-address-type-info';

// Web-specific adaptation (mobile uses use-handle-region-list-bottom-sheet.ts)
export { useHandleRegionListModal } from './use-handle-region-list-modal';
export type {
    UseHandleRegionListModalProps,
    UseHandleRegionListModalReturn,
    ModalExtraParamsProps,
} from './use-handle-region-list-modal';
